import {
  SEARCH_CONTROLS_DISPLAY_CHANGED,
  USER_REQUESTED_SEARCH,
} from '../../../actions/searchControls';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { SearchControlsState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/searchControls';

export const INITIAL_STATE: SearchControlsState = {
  isDisplaying: false,
  userRequestedSearch: false,
};

const searchControlsReducer = (
  state: SearchControlsState = INITIAL_STATE,
  action: Action,
): SearchControlsState => {
  switch (action.type) {
    case SEARCH_CONTROLS_DISPLAY_CHANGED:
      return {
        ...state,
        isDisplaying: action.payload.isDisplaying,
      };

    case USER_REQUESTED_SEARCH:
      return {
        ...state,
        userRequestedSearch: action.payload.searched,
      };

    default:
      return state;
  }
};

export const get = (state: SearchControlsState): SearchControlsState => state;
export const showSearchControls = (state: SearchControlsState): boolean => state.isDisplaying;
export const getUserRequestedSearch = (state: SearchControlsState): boolean =>
  state.userRequestedSearch;

export default searchControlsReducer;
